import React from 'react';

import { transformMedicationOptions } from '../../utils/transformMedicationOptions';
import type { ManufacturerEditCardFieldContainerProps } from '../../types/ManufacturerEditCardFieldContainerProps';
import { isManufacturerCardTypeEnabled } from '../../utils/isManufacturerCardTypeEnabled';

import MedicationSelectorDropdown from './MedicationSelectorDropdown';
import ManufacturerCardCheckbox from './ManufacturerCardCheckbox';

const ManufacturerGuestCardFieldContainer: React.FC<
  ManufacturerEditCardFieldContainerProps
> = ({
  manufacturerCardCheckboxProps,
  medicationSelectorDropdownProps,
  cardCategoriesConfigObject,
}) => {
  const transformedMedicationOptions =
    transformMedicationOptions(
      medicationSelectorDropdownProps.options,
    );

  if (
    isManufacturerCardTypeEnabled(cardCategoriesConfigObject)
  ) {
    return (
      <>
        <ManufacturerCardCheckbox
          {...manufacturerCardCheckboxProps}
        />

        {manufacturerCardCheckboxProps.value ? (
          <MedicationSelectorDropdown
            {...medicationSelectorDropdownProps}
            options={transformedMedicationOptions}
          />
        ) : null}
      </>
    );
  }
  return null;
};

export default ManufacturerGuestCardFieldContainer;
